import { Button } from "@/components/ui/button";
import { Check, X } from "lucide-react";

interface CropOverlayProps {
  onApply: () => void;
  onCancel: () => void;
}

export const CropOverlay = ({ onApply, onCancel }: CropOverlayProps) => {
  return (
    <div className="absolute top-4 right-4 flex gap-2 bg-white p-2 rounded-lg shadow-lg">
      <Button
        variant="outline"
        size="sm"
        onClick={onCancel}
        className="gap-1"
      >
        <X className="h-4 w-4" />
        Cancel
      </Button>
      <Button
        variant="default"
        size="sm"
        onClick={onApply}
        className="gap-1"
      >
        <Check className="h-4 w-4" />
        Apply
      </Button>
    </div>
  );
};